import type { FC, ReactElement } from 'react';
import { HashRouter as RRHashRouter } from 'react-router';
import { useEffect } from 'react';

import { MultiContextProvider } from '@luna/context';

import { useEnsureLeadingSlash } from './useEnsureLeadingSlash';
import { createRouteRootConfigContext } from '../feature-routing/routeConfigContext';
import { setHashRouterStrategy } from '../routerTypeStrategy';

interface Props {
    children: ReactElement;
    basename?: string;
}

const providers = [createRouteRootConfigContext(undefined)];

/** HashRouter will only be used in React features that are still called from backbone controllers.
 * This wrapper will ensure a leading slash in routes. */
export const HashRouter: FC<Props> = ({ children, basename }) => {
    useEnsureLeadingSlash();
    useEffect(() => {
        setHashRouterStrategy();
    }, []);

    return (
        <RRHashRouter basename={basename}>
            <MultiContextProvider providers={providers}>{children}</MultiContextProvider>
        </RRHashRouter>
    );
};
